import { Base } from "./Base";

export interface Province extends Base {
  code: number;
  name: string;
}

export const initProvince: Province = { id: -1, key: -1, code: -1, name: "" };
